// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { toggleModal } from '../../storage/actions/modalsActions';
import { reloadData } from '../../storage/actions/applicationStateActions';
import CustomSelect from '../layout/CustomSelect';
import { dashboard as dashboardSelectStyle, dashboardSelectClassNames } from '../../utils/customSelectStyle';
import SaveBankAccount from './BankPayments/SaveBankAccount';
import ConvergeSaveCard from './ElavonPayments/ConvergeSaveCard';

const PAYMENT_TYPE_OPTIONS = [
  { value: 'bank', label: 'Bank Account' },
  { value: 'card', label: 'Credit Card' },
];

const AddOrEditPaymentMethod = ({
  modalState,
  toggleModal,
  reloadData,
  auth,
}) => {
  const { type: paymentMethod } = modalState;
  const [isEditMode, setIsEditMode] = useState(false);
  const [addMethod, setAddMethod] = useState(PAYMENT_TYPE_OPTIONS[0]);

  useEffect(() => {
    if (paymentMethod) {
      setIsEditMode(true);
      setAddMethod(PAYMENT_TYPE_OPTIONS[1]);
    }
  }, [paymentMethod]);

  const closeModal = () => {
    setIsEditMode(false);
    setAddMethod(PAYMENT_TYPE_OPTIONS[0]);
    reloadData();
    toggleModal(false, 'addOrEditPaymentMethod');
  };

  const refreshPaymentMethodsListAndCloseModal = () => {
    closeModal();
  };

  if (!modalState.isOpen) {
    return null;
  }

  return (
    <div className="popup_block dashboard-modal dashboard-modal--payment showed">
      <div className="popup_container">
        <div className="popup_head">
          <div className="popup_title">
            {isEditMode ? 'Edit Payment Method' : 'Add Payment Method'}
          </div>
          <button type="button" className="close_btn" aria-label="close" onClick={closeModal}>
            ×
          </button>
        </div>

        <div className="popup_body">
          {!isEditMode && (
            <>
              <div className="field_col">
                <label className="field_name" htmlFor="payment-type-select">
                  Payment type
                </label>
                <div className="dashboard-select-wrap">
                  <CustomSelect
                    inputId="payment-type-select"
                    styles={dashboardSelectStyle}
                    classNames={dashboardSelectClassNames}
                    options={PAYMENT_TYPE_OPTIONS}
                    value={addMethod}
                    onChange={(option) => setAddMethod(option || PAYMENT_TYPE_OPTIONS[0])}
                    isSearchable={false}
                  />
                </div>
              </div>
              <div className="separate">
                <span>OR</span>
              </div>
            </>
          )}

          {addMethod.value === 'bank' && !isEditMode && (
            <>
              <SaveBankAccount onSuccess={refreshPaymentMethodsListAndCloseModal} />
              <p className="dashboard-payment-hint">
                Verification of micro deposits usually takes 2-3 days
              </p>
            </>
          )}

          {addMethod.value === 'card' && !isEditMode && (
            <ConvergeSaveCard
              user={auth.user}
              onSuccess={refreshPaymentMethodsListAndCloseModal}
            />
          )}

          {addMethod.value === 'card' && isEditMode && (
            <p className="dashboard-payment-hint">
              Editing a saved card is not available. Please remove this card and add a new one.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  modalState: state.modalState.addOrEditPaymentMethod,
  auth: state.auth,
});

export default connect(mapStateToProps, { toggleModal, reloadData })(AddOrEditPaymentMethod);
